// eslint-disable-next-line
import util from "util";

import React, { useEffect, useState } from "react";
import BlockIcon from "@material-ui/icons/Block";
import OutlinedPopover from "ui/OutlinedPopover";
// eslint-disable-next-line
import * as MuiCore from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { getAccountId } from "account/selectors";
import { getBlockNumbersByAccount } from "service/selectors";
import { blockPhoneNumber, editBlockPhoneNumber } from "service/actions";
import IntlTelInput from "react-intl-tel-input";
// import { parseInternationalPhoneNumber } from "./utils";

const initialFormState = {
  name: "",
  phoneNumber: "",
  company: "",
  showError: false,
  isValidNumber: false,
};

const BlockNumberForm = ({ open, close, formState: inputFormState = {} }) => {
  const [formState, setFormState] = useState(initialFormState);
  const [formOpen, setFormOpen] = useState(false);
  useEffect(() => {
    setFormState({
      ...initialFormState,
      ...inputFormState,
    });
  }, [inputFormState]);
  useEffect(() => {
    setFormOpen(open);
  }, [open]);
  const accountId = useSelector((state) => getAccountId(state));
  const dispatch = useDispatch();
  const blockNumbersList = useSelector((state) =>
    getBlockNumbersByAccount(state)
  );
  const resetForm = () => {
    setFormOpen(false);
    setTimeout(() => {
      setFormState(initialFormState);
      close();
    }, 200);
  };
  const handleIntlPhoneChange = (
    isValidNumber,
    value,
    countryData,
    number,
    id
  ) => {
    setFormState((state) => ({
      ...state,
      phoneNumber: `+${number.replace(/[^0-9]/g, "")}`,
      isValidNumber,
    }));
    // console.log(
    //   "In Change PHone number",
    //   isValidNumber,
    //   value,
    //   countryData,
    //   number,
    //   id
    // );
  };
  const saveNumber = (record, completed) => {
    try {
      // Validation to check if number has already been blocked
      if (
        inputFormState.updateEntryId ||
        !blockNumbersList?.find(
          (contact) => contact.phoneNumber === formState.phoneNumber
        )
      ) {
        if (inputFormState.updateEntryId) {
          dispatch(
            editBlockPhoneNumber({
              accountId,
              entryId: inputFormState.updateEntryId,
              phoneNumber: formState.phoneNumber,
              name: formState.name.length ? formState.name : undefined,
              company: formState.company.length ? formState.company : undefined,
              completed,
            })
          );
        } else {
          dispatch(
            blockPhoneNumber(
              accountId,
              formState.phoneNumber,
              formState.name.length ? formState.name : undefined,
              formState.company.length ? formState.company : undefined,
              completed
            )
          );
        }
        resetForm();
      } else {
        setFormState((state) => ({ ...state, showError: true }));
      }
    } catch (exception) {
      console.log("cannot save the number");
      return;
    }
  };
  // const { phoneNumber: formattedNumber, countryCode } =
  //   parseInternationalPhoneNumber(inputFormState.phoneNumber);
  return (
    <OutlinedPopover
      open={formOpen}
      icon={<BlockIcon color="primary" fontSize="large" />}
      title={`${
        inputFormState?.updateEntryId ? "Update" : "Add"
      } Phone Number to Block`}
      onClose={() => resetForm()}
    >
      <MuiCore.Grid container>
        <MuiCore.FormControl
          style={
            formState.isValidNumber
              ? { borderBottom: "1px solid black", width: "100%" }
              : { borderBottom: "1px solid red", width: "100%" }
          }
        >
          <IntlTelInput
            // defaultValue={formattedNumber}
            // defaultCountry={countryCode}
            defaultValue={inputFormState.phoneNumber}
            containerClassName="intl-tel-input"
            inputClassName="MuiInputBase-input"
            onPhoneNumberChange={handleIntlPhoneChange}
            preferredCountries={
              window.location.hostname.includes("uk") ? ["gb"] : ["us"]
            }
            format
            formatOnInit
            // nationalMode={false}
            placeholder={"(201) 555-0572"}
          />
        </MuiCore.FormControl>
        <MuiCore.TextField
          variant="outlined"
          placeholder="Name"
          InputLabelProps={{ shrink: true }}
          style={{ width: "100%", marginTop: "10px" }}
          InputProps={{
            style: { fontFamily: "Sofia", fontSize: 14 },
          }}
          inputProps={{
            maxLength: 100,
          }}
          value={formState.name}
          onChange={(e) => {
            setFormState((state) => ({ ...state, name: e.target.value }));
          }}
        />
        <MuiCore.TextField
          variant="outlined"
          placeholder="Company"
          style={{ width: "100%", marginTop: "10px" }}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            style: { fontFamily: "Sofia", fontSize: 14 },
          }}
          inputProps={{
            maxLength: 100,
          }}
          value={formState.company}
          onChange={(e) => {
            setFormState((state) => ({ ...state, company: e.target.value }));
          }}
        />

        {formState.showError && formState.phoneNumber.length >= 10 && (
          <MuiCore.Typography
            variant="body1"
            style={{ fontSize: 15, color: "red", marginTop: 5 }}
          >
            This phone number has already been blocked.
          </MuiCore.Typography>
        )}
      </MuiCore.Grid>

      <MuiCore.DialogActions style={{ paddingLeft: 20, paddingRight: 20 }}>
        <MuiCore.Button
          onClick={saveNumber}
          disabled={!formState.isValidNumber}
        >
          {inputFormState.updateEntryId ? "Update" : "Block"}
        </MuiCore.Button>
        <MuiCore.Button onClick={() => resetForm()}>Cancel</MuiCore.Button>
      </MuiCore.DialogActions>
    </OutlinedPopover>
  );
};

export default BlockNumberForm;
